export default __webpack_public_path__ + "594713c19fc7ccb70026c89fe72ff4a5.svg";